<!-- 报表 ==== 对比 -->
<template>
    <!-- 运营&绩效 - 概况 -->
    <div class="">
        <div class="flex-1">
            <span class="text-bold">{{ title }}</span>
            <span>{{ time_title }}</span>
        </div>
        <div class="block-preview">
            <div class="flex-wrap  details_content">
                <div
                    class="flex-align-center width-full flex-main-start"
                    style="line-height: 28px"
                >
                    <div v-if="headerShow[0]" :style="monthClass">
                        <component :is="header.time" @change="formatTime">
                        </component>
                        <component
                            :is="header.quckTime"
                            @change="time_change"
                            :tabPosition="tabPosition"
                        >
                        </component>
                        <div class="blank_div_cell"></div>
                        <component
                            :is="header.datePicker"
                            :class="compareClass[0]"
                            :time="query.time"
                            @change="changeStart"
                        >
                        </component>
                    </div>
                    <div
                        class="flex-main-start"
                        :class="padd_after"
                        v-if="headerShow[1]"
                    >
                        <span class="padding-right-s font-deep-gray-xxs"
                            >门店：</span
                        >

                        <!-- <el-cascader :class="compareClass[1]"
                         popper-class="select_drop_theme"
                         class="select_theme"
                         :props="{ expandTrigger: 'hover' }"
                         :options="storeList"
                         v-model="initStore"
                         @change="changeStore">
            </el-cascader> -->

                        <TotastFour
                            :project="allLiliaos"
                            initEmp="全部"
                            @changeStore="changeStore"
                        ></TotastFour>
                    </div>
                    <!-- <div
                        class="flex-main-start padding-left-40"
                        v-if="headerShow[2]"
                    >
                        <span class="padding-right-s font-deep-gray-xxs"
                            >门店：9</span
                        >
                        <el-select
                            :class="compareClass[2]"
                            v-model="queryData.isOld"
                            @change="changeCustomer"
                        >
                            <el-option
                                v-for="item in customerList"
                                :key="item.isOld"
                                :label="item.label"
                                :value="item.isOld"
                            >
                            </el-option>
                        </el-select>
                    </div> -->
                    <div
                        class="flex-main-start padding-left-40"
                        v-if="headerShow[2]"
                    >
                        <span class="padding-right-s font-deep-gray-xxs">
                            顾客：
                        </span>
                        <el-select
                            :class="compareClass[2]"
                            v-model="queryData.isOld"
                            @change="changeCustomer"
                        >
                            <el-option
                                v-for="item in customerList"
                                :key="item.isOld"
                                :label="item.label"
                                :value="item.isOld"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div
                        class="flex-main-start padding-left-40"
                        v-show="headerShow[3]"
                    >
                        <span class="padding-right-s font-deep-gray-xxs">
                            会员：
                        </span>
                        <el-select
                            :class="compareClass[3]"
                            v-model="queryData.customerType"
                            @change="changeMember"
                        >
                            <el-option
                                v-for="item in memberList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div
                        class="flex-main-start padding-left-40"
                        v-if="headerShow[7]"
                    >
                        <span class="padding-right-s font-deep-gray-xxs"
                            >储值卡：</span
                        >

                        <el-cascader
                            :class="compareClass[4]"
                            popper-class="select_drop_theme"
                            class="select-md-w"
                            :props="{ expandTrigger: 'hover' }"
                            v-model="cardType"
                            :options="cardList"
                            @change="changeCard"
                        ></el-cascader>

                        <!-- <el-select
              :class="compareClass[7]"
              v-model="cardType"
              @change="changeCard"
            >
              <el-option
                v-for="item in cardList"
                :key="item.cardType"
                :label="item.label"
                :value="item.cardType"
              >
              </el-option>
            </el-select> -->
                    </div>
                    <div
                        class="flex-main-start padding-left-40"
                        v-if="headerShow[8]"
                    >
                        <span class="padding-right-s font-deep-gray-xxs"
                            >理疗师：</span
                        >
                        <div class="button" :class="compareClass[8]">
                            <TotastThree
                                v-if="
                                    page.name == 'perform_contrast' ||
                                        page.name == 'perform_survey'
                                "
                                :isFirstStore="isFirstStore"
                                :project="levelProject"
                                initEmp="全部"
                                @change="changePer"
                            ></TotastThree>
                            <TotastTwo
                                v-else
                                :project="levelProject"
                                :allStore="false"
                                @change="changePer"
                                :dialog="dialogShow"
                                :initId="initId"
                                :empInitName="empInitName"
                            ></TotastTwo>
                        </div>
                    </div>
                    <div
                        class="flex-main-start padding-left-40"
                        v-if="headerShow[9]"
                    >
                        <span class="padding-right-s font-deep-gray-xxs"
                            >前台：</span
                        >
                        <div class="button" :class="compareClass[9]">
                            <!-- 对比情况下，获取前台树 -->
                            <TotastThreeForReceptionist
                                v-if="
                                    page.name == 'front_contract' || page.name == 'front_survey'
                                "
                                :project="levelProject"
                                initEmp="全部"
                                @change="changePer"
                            ></TotastThreeForReceptionist>
                            <!-- 非对比情况下 -->
                            <TotastTwoForReceptionist
                                v-else
                                :project="levelProject"
                                :allStore="false"
                                @change="changePer"
                                :dialog="dialogShow"
                                :empInitName="empInitName"
                            ></TotastTwoForReceptionist>
                        </div>
                    </div>
                    <div
                        class="flex-main-start padding-left-40"
                        v-if="headerShow[10]"
                    >
                        <span class="padding-right-s font-deep-gray-xxs"
                            >优惠券：</span>
                        <div class="button" :class="compareClass[10]">
                            <CouponsTotast
                                :dialog="page.couponsShow"
                                :couponsList="couponsList"
                                @change="changeCoupons"
                            ></CouponsTotast>
                        </div>
                    </div>
                    <div
                        class="right right_switch flex-nowrap"
                        v-if="contrastStatus"
                    >
                        <span class="font-deep-gray-xxs padding-right-s"
                            >对比：</span
                        >
                        <span class="padding-right-md">
                            <el-switch
                                v-model="switchStatus"
                                active-color="#3C76FF"
                                inactive-color="#EDEDED"
                                style="width: 120px"
                                @change="onContrast"
                            >
                            </el-switch>
                        </span>
                        <transition name="slide-fade">
                            <div v-if="switchStatus" class="flex-nowrap">
                                <el-select
                                    v-model="checkId"
                                    placeholder="请选择"
                                    @change="updateCheck"
                                >
                                    <el-option
                                        v-for="(item, index) in options"
                                        :key="index"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                                <span
                                    v-show="checked[0]"
                                    class="padding-left-10"
                                >
                                    <label>
                                        <div
                                            v-if="!showPick"
                                            class="a_pick font-theme"
                                            :style="{
                                                width:
                                                    header.datePicker ===
                                                    'MonthPicker'
                                                        ? '136px'
                                                        : '174px'
                                            }"
                                        >
                                            与其它时间段对比
                                        </div>
                                        <component
                                            month-id="test7"
                                            :is="header.datePicker"
                                            :time="query.time_contrast"
                                            @change="changeEnd"
                                        ></component>
                                    </label>
                                </span>
                                <span class="padding-left-10-new" v-if="checked[1]">
                                    <div class="el-select">
                                        <TotastFour
                                        :project="allLiliaos"
                                        initEmp="全部"
                                        class="store_class"
                                        @changeStore="changeStore_other"
                                        ></TotastFour>
                                    </div>
                                </span>
                                <span v-if="checked[2]" class="padding-left-10">
                                    <div class="el-select">
                                        <el-select
                                            class="font-theme"
                                            placeholder="选择对比顾客"
                                            v-model="queryData.compareIsOld"
                                            @change="changeCustomer_other"
                                        >
                                            <el-option
                                                v-for="item in customerList"
                                                :key="item.isOld"
                                                :label="item.label"
                                                :value="item.isOld"
                                            >
                                            </el-option>
                                        </el-select>
                                    </div>
                                </span>
                                <span class="padding-left-10" v-if="checked[3]">
                                    <div class="el-select">
                                        <el-select
                                            class="font-theme"
                                            placeholder="选择对比会员"
                                            v-model="queryData.compareCustType"
                                            @change="changeMember_other"
                                        >
                                            <el-option
                                                v-for="item in memberList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            >
                                            </el-option>
                                        </el-select>
                                    </div>
                                </span>
                                <span class="padding-left-10" v-if="checked[7]">
                                    <div class="el-select">
                                        <el-select
                                            class="font-theme"
                                            placeholder="选择对比储值卡类型"
                                            v-model="queryData.compareCardType"
                                            @change="changeCard_other"
                                        >
                                            <el-option
                                                v-for="item in cardList"
                                                :key="item.cardType"
                                                :label="item.label"
                                                :value="item.cardType"
                                            >
                                            </el-option>
                                        </el-select>
                                    </div>
                                </span>
                                <div class="p-l-10" v-if="checked[8]">
                                    <div>
                                        <div class="button font-theme">
                                            <totastTwo
                                                :project="levelProject"
                                                @change="changePerContrant"
                                                :compare="true"
                                            ></totastTwo>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-l-10" v-if="checked[10]">
                                    <div>
                                        <div class="button font-theme">
                                            <CouponsTotast
                                                :couponsList="couponsList"
                                                @change="changeCouponsContrant"
                                                initCou="选择对比优惠券"
                                            ></CouponsTotast>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                    <div v-if="headerShow[13]" style="display: flex;align-items: center;">
                        时间：
                        <el-select
                            v-if="timeRange && timeRange.length > 0"
                            v-model="timeRangeSelected"
                            placeholder="请选择类型"
                            :style="{width: '90px', marginRight: '10px'}"
                            @change="handleTimeRangeChange"
                        >
                            <el-option
                                v-for="(item, index) in timeRange"
                                :key="item.value"
                                :label="item.label"
                                :value="index"
                            >
                            </el-option>
                        </el-select>
                        <el-radio-group v-if="!header.hideSearchType" v-model="yearType" @change="yearTypeChange">
                            <el-radio-button :label="1">今年</el-radio-button>
                            <el-radio-button :label="2">去年</el-radio-button>
                        </el-radio-group>
                        <el-date-picker
                            style="margin-left: 10px;width: 80px"
                            v-model="yearValue"
                            @change="yearValueChange"
                            :picker-options="pickerOptions"
                            type="year"
                            :clearable="false"
                            :editable="false"
                            format="yyyy年"
                            placeholder="选择年">
                            </el-date-picker>
                    </div>
                    <div v-if="headerShow[14]" style="display: flex;align-items: center;">
                        时间：
                        <el-select
                            v-if="timeRange && timeRange.length > 0"
                            v-model="timeRangeSelected"
                            placeholder="请选择类型"
                            :style="{width: '90px', marginRight: '10px'}"
                            @change="handleTimeRangeChange"
                        >
                            <el-option
                                v-for="(item, index) in timeRange"
                                :key="item.value"
                                :label="item.label"
                                :value="index"
                            >
                            </el-option>
                        </el-select>
                        <el-radio-group v-if="!header.hideSearchType" v-model="quarterlyType" @change="quarterlyTypeChange">
                            <el-radio-button :label="1">本季度</el-radio-button>
                            <el-radio-button :label="2">上季度</el-radio-button>
                        </el-radio-group>
                        <el-quarter-range-picker style="margin-left:10px" :value.sync="quarterValue" @change="quarterValueChange">
                        </el-quarter-range-picker>
                    </div>
                    <div v-if="headerShow[15]" style="display: flex;align-items: center;">
                        时间：
                        <el-select
                            v-if="timeRange && timeRange.length > 0"
                            v-model="timeRangeSelected"
                            placeholder="请选择类型"
                            :style="{width: '90px', marginRight: '10px'}"
                            @change="handleTimeRangeChange"
                        >
                            <el-option
                                v-for="(item, index) in timeRange"
                                :key="item.value"
                                :label="item.label"
                                :value="index"
                            >
                            </el-option>
                        </el-select>
                        <el-radio-group v-if="!header.hideSearchType" v-model="monthType" @change="monthTypeChange">
                            <el-radio-button :label="1">本月</el-radio-button>
                            <el-radio-button :label="2">上月</el-radio-button>
                            <el-radio-button :label="3">近三个月</el-radio-button>
                        </el-radio-group>
                        <el-date-picker
                            style="margin-left: 10px;"
                            v-model="monthValue"
                            @change="monthValueChange"
                            type="monthrange"
                            :clearable="false"
                            :picker-options="monthPickerOptions"
                            placeholder="选择月份">
                            </el-date-picker>
                    </div>
                    <div v-if="headerShow[17]" style="display: flex;align-items: center;">
                        时间：
                        <el-select
                            v-if="timeRange && timeRange.length > 0"
                            :value="timeRangeSelected"
                            placeholder="请选择类型"
                            :style="{width: '90px', marginRight: '10px'}"
                            @change="handleTimeRangeChange"
                        >
                            <el-option
                                v-for="(item, index) in timeRange"
                                :key="item.value"
                                :label="item.label"
                                :value="index"
                            >
                            </el-option>
                        </el-select>
                        <el-radio-group v-if="!header.hideSearchType && !header.isMarketing" v-model="quarterlyTypeCustom" @change="quarterlyTypeChangeCustom">
                            <el-radio-button :label="1">本季度</el-radio-button>
                            <el-radio-button :label="2">上季度</el-radio-button>
                        </el-radio-group>
                        <el-quarter-range style="margin-left:10px" :value.sync="quarterValueCustom" @change="quarterValueChangeCustom">
                        </el-quarter-range>
                    </div>
                    <div v-if="headerShow[16]" style="margin-left: 20px;display: flex;align-items: center;flex-wrap: nowrap;">
                        维度：
                        <el-select v-model="dimensionValue" style="width: 100px;" placeholder="请选择">
                            <el-option
                            v-for="item in dimensionOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <TotastFour
                            style="margin-left: 10px;"
                            v-if="dimensionValue === 8"
                            :project="allLiliaos"
                            initEmp="全部"
                            @changeStore="changeStore"
                        ></TotastFour>
                        <!-- 区域 -->
                        <el-select v-if="dimensionValue === 19" @change="areaValueChange" collapse-tags multiple v-model="areaValue" style="width: 200px;margin-left: 10px;" placeholder="请选择">
                            <el-option
                            v-for="item in getArea"
                            :key="item.constKey"
                            :label="item.constVal"
                            :value="item.constKey">
                            </el-option>
                        </el-select>
                        <!-- 公司 -->
                        <el-select v-if="dimensionValue === 18" @change="companyValueChange" collapse-tags multiple v-model="companyValue" style="width: 200px;margin-left: 10px;" placeholder="请选择">
                            <el-option
                            v-for="item in getCompany"
                            :key="item.constKey"
                            :label="item.constVal"
                            :value="item.constKey">
                            </el-option>
                        </el-select>
                        <!-- 集团 -->
                        <el-select v-if="dimensionValue === 17" @change="groupValueChange" collapse-tags multiple v-model="groupValue" style="width: 200px;margin-left: 10px;" placeholder="请选择">
                            <el-option
                            v-for="item in getGroup"
                            :key="item.constKey"
                            :label="item.constVal"
                            :value="item.constKey">
                            </el-option>
                        </el-select>
                    </div>
                    <div v-if="headerShow[18]"  style="display: flex;align-items: center;margin-left: 12px;">
                        维度：
                        <el-select v-model="dimensionValueOne" style="width: 100px;" placeholder="请选择">
                            <el-option
                            v-for="item in getDimensionOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <storeOne v-if="dimensionValueOne === 8" :value.sync="storeId"></storeOne>
                        <!-- 区域 -->
                        <el-select v-if="dimensionValueOne === 19" @change="areaValueOneChange" v-model="areaValueOne" style="width: 200px;margin-left: 10px;" placeholder="请选择">
                            <el-option
                            v-for="item in getArea"
                            :key="item.constKey"
                            :label="item.constVal"
                            :value="item.constKey">
                            </el-option>
                        </el-select>
                        <!-- 公司 -->
                        <el-select v-if="dimensionValueOne === 18" @change="companyValueOneChange" v-model="companyValueOne" style="width: 200px;margin-left: 10px;" placeholder="请选择">
                            <el-option
                            v-for="item in getCompany"
                            :key="item.constKey"
                            :label="item.constVal"
                            :value="item.constKey">
                            </el-option>
                        </el-select>
                        <!-- 集团 -->
                        <el-select v-if="dimensionValueOne === 17" @change="groupValueOneChange" v-model="groupValueOne" style="width: 200px;margin-left: 10px;" placeholder="请选择">
                            <el-option
                            v-for="item in getGroup"
                            :key="item.constKey"
                            :label="item.constVal"
                            :value="item.constKey">
                            </el-option>
                        </el-select>
                    </div>
                    <!-- <div
                        class="flex-main-start"
                        :class="padd_after"
                        v-if="headerShow[4]"
                    >
                        <vipHeaderDialog :propDateRange="[queryData.startTime,queryData.endTime]" :headerMemberInfoQueryParam.sync="headerMemberInfoQueryParam" />
                    </div> -->
                </div>
            </div>
        </div>
        <!-- <vipHeaderDialog /> -->
    </div>
</template>

<script>
import * as util from '../../../common/util'
import * as queryUtil from '../../../common/query'
import * as consts from '../../../common/const'
import * as config from '../../../common/config'
import moment from 'moment'
import elQuarterRangePicker from './el-quarter-range-picker/index.vue'
import elQuarterRange from './el-quarter-range/index.vue'
import { mapGetters } from 'vuex'
import { header } from './component'
import storeOne from '../header/store_one.vue'
import { EventBus } from '@/common/eventBus'

export default {
    components: {
        ...header,
        elQuarterRangePicker,
        elQuarterRange,
        storeOne
    },
    props: {
        title: [String],
        constantKey: [String],
        empInitName: [String],
        constantKeyOne: [String],
        constantKeyTwo: [String],
        identifyKey: [String],
        contrastStatus: {
            type: Boolean,
            default: function() {
                return true
            }
        },
        headerChange: [Boolean],
        header: [Object],
        sortIndex: [Number],
        page: [Object],
        type: [Number],
        initId: [Number],
        dateFormat: [Number],
        headerType: [Number],
        parentID: [Number],
        headerShow: [Array],
        isFirstStore: {
            type: Boolean,
            default: false
        },
        padd_after: {
            type: String,
            default: function() {
                return 'padding-left-40'
            }
        },
        timeRange: {
            type: Array,
            default: () => ([])
        },
    },
    data() {
        const start = moment().startOf('quarter').format('YYYY-MM')
        const first = moment().format('YYYY') + '-01'
        const end = moment().endOf('quarter').format('YYYY-MM')
        return {
            timeRangeSelected: 0,
            dimensionValue: 8,
            switchStatus: false,
            query: {
                time: [],
                time_contrast: [],
                time_contrastEnd: []
            },
            store: JSON.parse(localStorage.getItem('store')) || [],
            queryData: {
                startTime: '',
                endTime: '',
                storeID: JSON.parse(localStorage.getItem('store'))[0]
                    .children[0].value,
                customerType: consts.MemberClass[0].value,
                isOld: consts.CustomerClass[0].isOld,
                miniPrice: 0,
                maxPrice: 0,
                empID: null,
                compareType: 0,
                paramName: '全部',
                compareParam: '',
                comParamName: '',
                identifyKey: 0,
                headerType: 0,
                constantKey: '',
                parentID: 0,
                constantType: 0,
                type: 0,
                categoryID: '',
                prodID: 0,
                dateFormat: 1,
                pageNum: 1,
                sortIndex: 1,
                ascending: 0,
                sqlType: 1,
                pageSize: 20,
                status: 1,
                storeIDs: null,
                timelyType: undefined,
            },
            customerList: consts.CustomerClass,
            memberList: consts.MemberClass,
            cardList: consts.cardTypeList,
            cardType: consts.cardTypeList[0].value,
            initStore: ['上海', 0],
            tabPosition: '最近30天',
            time_title: '',
            checkId: 1,
            checked: [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false
            ],
            showPick: false,
            monthClass: 'display:flex',
            empName: '',
            couponsShow: true,
            couponsList: [],
            dimensionOptions: [
                {label: '门店', value: 8},
                {label: '区域', value: 19},
                {label: '公司', value: 18},
                {label: '集团', value: 17},
            ],
            yearType: 1,
            yearValue: moment().format('YYYY'),
            quarterly: '',
            monthType: 1,
            monthValue: [moment().format('YYYY-MM'),moment().format('YYYY-MM')],
            areaValue: [],
            companyValue: [],
            groupValue: [],
            areaValueOne: '',
            companyValueOne: '',
            groupValueOne: '',
            quarterlyType: 1,
            quarterValue: [start, end],
            quarterValueCustom: [first, end],
            quarterlyTypeCustom: 1,
            storeId: '',
            dimensionValueOne: 8,
            headerMemberInfoQueryParam: null
        }
    },
    async created() {
        if(this.header.isMarketing){
            this.dimensionValueOne =  18
        }
        if(this.headerShow[16] || this.headerShow[18]){
            this.$store.dispatch("getGroup", {areaType: 4})
            this.$store.dispatch("getCompanyList", {areaType: 3})
            this.$store.dispatch("getAreaList", {areaType:2})
        }
        const log = console.log.bind(console)
        if (this.header.time === 'Month') this.monthClass = ''
        // 特殊情况。理疗师详情页面，由概况的列表点击跳转进来，有初始默认值，否则弹框提示
        log('child component is created')
        if (this.initId === 0 || this.initId === undefined) {
            this.dialogShow = true
        } else {
            this.queryData.empID = this.initId
            queryUtil.setQuery(this.queryData)
            this.dialogShow = false
        }
        var {
            headerType,
            constantKey,
            parentID,
            type,
            dateFormat,
            sqlType,
            sortIndex,
            timelyType,
            areaType
        } = this.page
        this.queryData = Object.assign(
            {},
            this.queryData,
            {
                headerType,
                constantKey,
                parentID,
                type,
                dateFormat,
                sqlType,
                sortIndex,
                timelyType,
                areaType
            },
            { identifyKey: this.page.tableKey }
        )
        if (this.header.quckTime === 'MonthTab') {
            this.tabPosition = '最近3个月'
            this.tab_time = this.query.time = util.report.getMonth(
                this.tabPosition
            )
            let time = util.report.queryMoreMonth(this.tab_time)
            this.time_change([time.startTime, time.endTime])
        } else if (this.header.quckTime === 'MonthTabSix') {
            this.tabPosition = '最近6个月'
            this.tab_time = this.query.time = util.report.getMonth(
                this.tabPosition
            )
            let time = util.report.queryMoreMonth(this.tab_time)
            this.time_change([time.startTime, time.endTime])
        } else {
            if (this.header.quckTime === 'TimeTab') {
                this.tabPosition = '上周'
            } else if (
                this.header.quckTime === 'MonthTabTwo' ||
                this.header.quckTime === 'MonthTabThree'
            ) {
                this.tabPosition = '最近7天'
            } else if (this.header.quckTime === 'MonthTabSix') {
                this.tabPosition = '最近6个月'
            }
            this.tab_time = this.query.time = util.report.getime(
                this.tabPosition
            )
            let time = util.report.getime(this.tabPosition)
            this.queryData = Object.assign(
                {},
                this.queryData,
                util.report.queryTime(time)
            )
            queryUtil.setQuery(this.queryData)
        }
        if (this.header.time === 'Month') {
            // this.$nextTick(() => {
            let val = this.moment().format('YYYY-MM')
            this.time_title = '（' + val + ')'
            this.queryData = Object.assign(
                {},
                this.queryData,
                util.report.queryMonth(val)
            )
            queryUtil.setQuery(this.queryData)
            // })
        }else if (this.header.time === 'Year') {
            // this.$nextTick(() => {
            let val = this.moment().format('YYYY')
            this.time_title = '（' + val + ')'
            this.queryData = Object.assign(
                {},
                this.queryData,
                {month: val, startTime: this.moment().format('YYYY-MM-DD'), endTime: this.moment().format('YYYY-MM-DD')}
            )
            queryUtil.setQuery(this.queryData)
            // })
        }else if (this.header.time === 'monthRange') {
            // this.$nextTick(() => {
            let val = this.moment().format('YYYY-MM')
            this.time_title = '（' + val + '~' + val + ')'
            this.queryData = Object.assign(
                {},
                this.queryData,
                {startTime: val, endTime: val}
            )
            queryUtil.setQuery(this.queryData)
            // })
        }else if(this.header.time === 'quarter'){
            const start = moment().startOf('quarter').format('YYYY-MM')
            const end = moment().endOf('quarter').format('YYYY-MM')
            this.time_title = '（' + start + '~' + end + ')'
            this.queryData = Object.assign(
                {},
                this.queryData,
                {startTime: start, endTime: end}
            )
            queryUtil.setQuery(this.queryData)
        }else if(this.header.time === 'quarterRange'){
            const start = moment().format('YYYY-01')
            const end = moment().endOf('quarter').format('YYYY-MM')
            this.time_title = '（' + start + '~' + end + ')'
            this.queryData = Object.assign(
                {},
                this.queryData,
                {startTime: start, endTime: end}
            )
            queryUtil.setQuery(this.queryData)
        }
            log('set Query', this.queryData)
    },
    computed: {
        ...mapGetters(['getGroup','getCompany','getArea']),
        getDimensionOptions(){
            return this.dimensionOptions.filter(v => [17,18].includes(v.value))
        },
        pickerOptions(){
            return {
                disabledDate(time) {
                    return time.getTime() > Date.now() || time.getTime() < moment('2023').toDate().getTime()
                }
            }
        },
        monthPickerOptions(){
            return {
                disabledDate(time) {
                    return time.getTime() > Date.now() || time.getTime() < moment('2023').toDate().getTime()
                }
            }
        },
        options() {
            let a = []
            console.log("this.headerShow",this.headerShow)
            this.headerShow.forEach((item, i) => {
                if (item && this.header.options[i]) {
                    a.push(this.header.options[i])
                }
            })
            if (this.header.name === 'perform_contrast') {
                a.pop()
            }
            return a
        },
        tab_time: {
            get() {
                return util.report.getime(this.tabPosition)
            },
            set(val) {
                const self = this
                self.time_title =
                    val[0].length <= 10
                        ? `（${val.join(' ~ ')}）`
                        : `（${val.join(' 与 ')}）`
            }
        },
        compareClass() {
            let theme = []
            theme = this.checked.map(check => {
                return this.contrastStatus && check ? 'font-theme' : ''
            })
            return theme
        },
        storeList() {
            return this.store
        },
        levelProject() {
            let str = JSON.parse(localStorage.getItem('treeStore'))
            // if (str.length) {
            //     str.forEach(item => {
            //         if (queryUtil.filterType(item.children)) {
            //             item.children.splice(0, 1)
            //         }
            //     })
            // }
            return str
        },
        allLiliao() {
            let str = JSON.parse(localStorage.getItem('treeStore'))
            // str[0].children.splice(0, 1)
            // str[0].children.forEach(item => {
            //     item.id = item.value
            // })
            // // str[0].children.unshift({id:0,label:'全部',value:0})
            // let a = [
            //     {
            //         id: 1,
            //         label: '上海',
            //         children: [
            //             {
            //                 id: 0,
            //                 label: '全部',
            //                 value: 0,
            //                 children: str[0].children
            //             }
            //         ]
            //     }
            const list = [
                str
            ]
            // ]
            // console.log('树状图', a)
            return list
        },

        allLiliaos() {
            let b = []
            b.push(JSON.parse(localStorage.getItem('regionaList')))
            return b
        }
    },
    watch: {
        contrastStatus(val) {
            const self = this
            if (val && self.checked[0]) {
                let b = self.queryData.compareParam.split('/')
                self.tab_time = [
                    `${self.queryData.startTime}~${self.queryData.endTime} 与
                         ${b[0]}~${b[1]} `
                ]
            } else {
                self.tab_time = [
                    self.queryData.startTime,
                    self.queryData.endTime
                ]
                this.queryData.compareType = 0
                this.queryData.comParamName = ''
                this.queryData.compareParam = ''
                queryUtil.setQuery(this.queryData)
            }
        },
        storeId(val, newValue){
            this.queryData.storeIDs = [val]
            queryUtil.setQuery(this.queryData)
        },
        // 切换卡片，表头的某一项不显示，则归为原始值
        headerShow(v) {
            // console.log(this.headerChange,v);
            if (this.headerChange) {
                v.forEach((item, i) => {
                    if (!item) {
                        switch (i) {
                            case 2:
                                this.queryData.isOld =
                                    consts.CustomerClass[0].isOld
                                // this.queryData.isOldName=consts.CustomerClass[0].label
                                break
                            case 3:
                                this.queryData.customerType =
                                    consts.MemberClass[0].value
                                // this.queryData.custTypeName=consts.MemberClass[0].label
                                break
                            case 4:
                                this.initPass = [-1]
                                this.queryData.bookSource =
                                    consts.passFlow[0].value
                                this.queryData.memberInfoQueryParam = null
                                // this.queryData.bookSourceName=consts.passFlow[0].label
                                break
                            case 5:
                                // 4和5会冲突，所以当4显示时，5不做任何处理
                                if (!v[4]) {
                                    this.queryData.bookSource =
                                        consts.passFlow[0].value
                                }
                                // this.queryData.bookSourceName=consts.passFlow[0].label
                                break
                            case 6:
                                this.queryData.prodID = 0
                                this.queryData.categoryID = ''
                                this.initProject = [0]
                                break
                            case 7:
                                this.queryData.maxPrice = 0
                                this.queryData.miniPrice = 0
                                this.cardType = -1
                                break
                            default:
                                break
                        }
                    }
                })
                queryUtil.setQuery(this.queryData)
            }
        },
        constantKey(v) {
            this.queryData.constantKey = v
            queryUtil.setQuery(this.queryData)
        },
        constantKeyOne(v) {
            this.queryData.constantKey1 = v
            queryUtil.setQuery(this.queryData)
        },
        constantKeyTwo(v) {
            this.queryData.constantKey2 = v
            queryUtil.setQuery(this.queryData)
        },
        identifyKey(v) {
            this.queryData.identifyKey = v
            // console.log(v);
            queryUtil.setQuery(this.queryData)
        },
        type(v) {
            this.queryData.type = v
            queryUtil.setQuery(this.queryData)
        },
        headerType(v) {
            this.queryData.headerType = v
            queryUtil.setQuery(this.queryData)
        },
        'page.sqlType': {
            deep: true, // 深度监听设置为 true
            handler: function(newV) {
                this.queryData.sqlType = newV
                queryUtil.setQuery(this.queryData)
            }
        },
        parentID(v) {
            this.queryData.parentID = v
            queryUtil.setQuery(this.queryData)
        },
        dateFormat(v) {
            this.queryData.dateFormat = v
            queryUtil.setQuery(this.queryData)
        },
        yearValue(v) {
            this.queryData.month = moment(v).format('YYYY')
            // console.log(v);
            this.time_title = '（' + this.queryData.month + ')'
            queryUtil.setQuery(this.queryData)
        },
        quarterValue(v){
            if(!v){
                this.queryData.startTime = ''
                this.queryData.endTime = ''
            }else{
                this.queryData.startTime = moment(v[0]).format('YYYY-MM')
                this.queryData.endTime = moment(v[1]).format('YYYY-MM')
                this.queryData.month = moment(v[0]).format('YYYY')
                this.time_title = '（' + this.queryData.startTime + '~' + this.queryData.endTime + ')'
            }
            queryUtil.setQuery(this.queryData)
        },
        quarterValueCustom(v){
            if(!v){
                this.queryData.startTime = ''
                this.queryData.endTime = ''
            }else{
                this.queryData.startTime = moment(v[0]).format('YYYY-MM')
                this.queryData.endTime = moment(v[1]).format('YYYY-MM')
                this.queryData.month = moment(v[0]).format('YYYY')
                this.time_title = '（' + this.queryData.startTime + '~' + this.queryData.endTime + ')'
            }
            queryUtil.setQuery(this.queryData)
        },
        monthValue: {
            handler: function(v) {
                if(!v){
                    this.queryData.startTime = ''
                    this.queryData.endTime = ''
                }else{
                    this.queryData.startTime = moment(v[0]).format('YYYY-MM')
                    this.queryData.endTime = moment(v[1]).format('YYYY-MM')
                    this.queryData.month = moment(v[0]).format('YYYY-MM')
                    this.time_title = '（' + this.queryData.startTime + '~' + this.queryData.endTime + ')'
                }
                // console.log(v);
                queryUtil.setQuery(this.queryData)
            },
            deep: true
        },
        dimensionValue(v){
            const obj = {
                8: 1,
                19: 2,
                18: 3,
                17: 4
            }
            this.queryData = {
                ...this.queryData,
                storeIDs: [],
                constantType: v,
                areaType: obj[v],
                areaIds: []
            }
            this.areaValue = []
            this.companyValue = []
            this.groupValue = []
            queryUtil.setQuery(this.queryData)
        },
        dimensionValueOne(v){
            const obj = {
                8: 1,
                19: 2,
                18: 3,
                17: 4
            }
            this.queryData = {
                ...this.queryData,
                storeIDs: [],
                constantType: v,
                areaType: obj[v],
                areaIds: []
            }
            this.areaValueOne = ''
            this.companyValueOne = ''
            this.groupValueOne = ''
            if(v === 8){
                this.queryData.storeIDs = [this.storeId]
            }
            queryUtil.setQuery(this.queryData)
        },
    },
    methods: {
        disabledDate(time) {
            return time.getTime() > Date.now() - 8.64e7; // 8.64e7 毫秒数代表一天
        },
        quarterlyTypeChange(val){
            if(val === 1){
                const start = moment().startOf('quarter').format('YYYY-MM')
                const end = moment().endOf('quarter').format('YYYY-MM')
                this.quarterValue = [start,end]
            }else if(val === 2){
                const start = moment().quarter(moment().quarter() - 1).startOf('quarter').format('YYYY-MM')
                const end = moment().quarter(moment().quarter() - 1).endOf('quarter').format('YYYY-MM')
                this.quarterValue = [start, end]
            }
        },
        quarterlyTypeChangeCustom(val){
            let start, end
            if(val === 1){
                start = moment().format('YYYY-01')
                end = moment().endOf('quarter').format('YYYY-MM')
                this.quarterValueCustom = [start,end]
            }else if(val === 2){
                if(moment().quarter() === 1){
                    // 去上一年的
                    start = parseInt(moment().format('YYYY')) - 1 + '-01'
                    end = parseInt(moment().format('YYYY')) - 1 + '-12'
                }else{
                    start = moment().quarter(moment().quarter() - 1).startOf('quarter').format('YYYY-01')
                    end = moment().quarter(moment().quarter() - 1).endOf('quarter').format('YYYY-MM')
                }
                this.quarterValueCustom = [start, end]
            }
        },
        quarterValueChange(v){
            console.log(v, '********************************')
            // const nowQuarter = moment().startOf('quarter').format('YYYY-MM')
            // const preQuarter = moment().quarter(moment().quarter() - 1).startOf('quarter').format('YYYY-MM')
            // if(v === nowQuarter){
            //     this.quarterlyType = 1
            // }else if(v === preQuarter){
            //     this.quarterlyType = 2
            // }else{
            //     this.quarterlyType = ''
            // }
        },
        quarterValueChangeCustom(v){
            if(!v){
                return
            }
            const nowQuarter = moment().endOf('quarter').format('YYYY-MM')
            const preQuarter = moment().quarter(moment().quarter() - 1).endOf('quarter').format('YYYY-MM')
            console.log(nowQuarter, 'nowQuarter')
            console.log(v[1],'v1')
            if(v[1] === nowQuarter){
                this.quarterlyTypeCustom = 1
            }else if(v[1] === preQuarter){
                this.quarterlyTypeCustom = 2
            }else{
                this.quarterlyTypeCustom = ''
            }
        },
        areaValueChange(v) {
            this.queryData.storeIDs = this.areaValue
            this.queryData.areaIds = this.areaValue
            this.queryData.storeID = undefined
            queryUtil.setQuery(this.queryData)
        },
        companyValueChange(v) {
            this.queryData.storeIDs = this.companyValue
            this.queryData.areaIds = this.companyValue
            this.queryData.storeID = undefined
            queryUtil.setQuery(this.queryData)
        },
        groupValueChange(v) {
            this.queryData.storeIDs = this.groupValue
            this.queryData.areaIds = this.groupValue
            this.queryData.storeID = undefined
            queryUtil.setQuery(this.queryData)
        },
        areaValueOneChange(v) {
            this.queryData.storeIDs = [this.areaValueOne]
            this.queryData.areaIds = [this.areaValueOne]
            this.queryData.storeID = undefined
            queryUtil.setQuery(this.queryData)
        },
        companyValueOneChange(v) {
            this.queryData.storeIDs = [this.companyValueOne]
            this.queryData.areaIds = [this.companyValueOne]
            this.queryData.storeID = undefined
            queryUtil.setQuery(this.queryData)
        },
        groupValueOneChange(v) {
            this.queryData.storeIDs = [this.groupValueOne]
            this.queryData.areaIds = [this.groupValueOne]
            this.queryData.storeID = undefined
            queryUtil.setQuery(this.queryData)
        },
        monthTypeChange(val){
            if(val === 1){
                this.monthValue = [moment().format('YYYY-MM'),moment().format('YYYY-MM')]
            }else if(val === 2){
                const month = moment().month(moment().month() - 1).startOf('month')
                this.monthValue = [month,month]
            }else if(val === 3){
                const month = moment().month(moment().month() - 2).startOf('month')
                this.monthValue = [month, moment().format('YYYY-MM')]
            }
        },
        monthValueChange(v){
            const nowMonth = moment().format('YYYY-MM')
            const lastMonth = moment().month(moment().month() - 1).startOf('month')
            const threeMonth = moment().month(moment().month() - 2).startOf('month')
            if(!val) return
            if(val[0] === nowMonth && val[1] === nowMonth){
                this.monthType = 1
            }else if(val[0] === lastMonth && val[1] === lastMonth){
                this.monthType = 2
            }else if(val[0] === threeMonth && val[1] === nowMonth){
                this.monthType = 3
            }else;{
                this.monthType = ''
            }
        },
        yearTypeChange(val){
            if(val === 1){
                this.yearValue = moment().format('YYYY')
            }else if(val === 2){
                this.yearValue = moment().year(moment().year() - 1).startOf('year')
            }
        },
        yearValueChange(val){
            if(moment(val).format('YYYY') === moment().year(moment().year() - 1).startOf('year').format('YYYY')){
                this.yearType = 2
            }else if(moment(val).format('YYYY') === moment().format('YYYY')){
                this.yearType = 1
            }else{
                this.yearType = ''
            }
        },
        updateQuery() {
            const self = this
            queryUtil.setQuery(self.queryData)
            queryUtil.setQueryTable(consts.clearTableQuery)
        },
        clearQuery(v) {
            const self = this
            self.query = Object.assign({}, self.query, {
                time_contrast: v
            })
        },
        // 时间：月
        formatTime(val) {
            let a = this.moment(val).format('YYYY-MM')
            this.time_title = '（' + a + ')'
            this.queryData = Object.assign(
                {},
                this.queryData,
                util.report.queryMonth(val)
            )
            queryUtil.setQuery(this.queryData)
        },
        // 快捷切换3,6,9月
        time_change(val) {
            const self = this
            self.tab_time = self.query.time = val
            // this.$bus.$emit('select_header',self.query)
            self.$emit('select_header', self.query)
            self.changeStart(val)
        },
        // 改变时间
        changeStart(val) {
            const self = this
            let start = []
            if (this.header.datePicker === 'DatePicker') {
                // 时间选择器为年月日
                start = val.map(item => self.moment(item).format('YYYY-MM-DD'))
            } else if (this.header.datePicker === 'MonthPicker') {
                // 时间选择器为年月
                if (val[0].split('-').length <= 2) {
                    start.push(
                        self
                            .moment(val[0])
                            .startOf('month')
                            .format('YYYY-MM-DD')
                    )
                    if (self.moment().format('YYYY-MM') === val[1]) {
                        start.push(
                            self
                                .moment()
                                .subtract(1, 'days')
                                .format('YYYY-MM-DD')
                        )
                    } else {
                        start.push(
                            self
                                .moment(val[1])
                                .endOf('month')
                                .format('YYYY-MM-DD')
                        )
                    }
                } else {
                    start = val
                }
            }
            self.query.time = start
            self.tabPosition = util.report.timeTab(start)
            self.query.time_contrast = util.report.sameTime(start)
            // 数据层
            let time = util.report.queryCompareTime(self.query.time_contrast)
            if (self.queryData.compareType === 1) {
                self.queryData = Object.assign(
                    {},
                    self.queryData,
                    util.report.queryTime(start),
                    time
                )
                self.tab_time = [
                    self.query.time.join('~'),
                    self.query.time_contrast.join('~')
                ]
                self.queryData.compareParam = self.query.time_contrast.join('/')
            } else {
                self.queryData = Object.assign(
                    {},
                    self.queryData,
                    util.report.queryTime(start)
                )
                self.tab_time = start
            }
            self.$emit('select_header', self.query)
            self.updateQuery()
        },
        // 改变门店
        changeStore(val) {
            this.queryData.storeIDs = val.empIDs
            queryUtil.setQuery(this.queryData)
        },
        // 改变顾客类型
        changeCustomer(val) {
            this.customerList.forEach(item => {
                if (item.isOld === val) {
                    if (this.queryData.compareType === 6) {
                        this.queryData.paramName = item.label
                    }
                    this.queryData.isOld = val
                }
            })
            queryUtil.setQuery(this.queryData)
        },
        // 改变会员类型
        changeMember(val) {
            this.memberList.forEach(item => {
                if (item.value === val) {
                    if (this.queryData.compareType === 3) {
                        this.queryData.paramName = item.label
                    }
                    this.queryData.customerType = val
                }
            })
            queryUtil.setQuery(this.queryData)
        },
        // 改变储值卡类型
        changeCard(val) {
            console.log(val)
            console.log(val.length)

            if (val.length !== 1) {
                this.queryData.cardType = val[1]
            } else {
                this.queryData.cardType = val[0]
            }
            // this.cardList.forEach(item => {
            //   if (item.cardType === val) {
            //     switch (item.label) {
            //       case "全部":
            //         this.queryData.miniPrice = 0;
            //         this.queryData.maxPrice = 0;
            //         // this.queryData.paramName=item.label
            //         break;
            //       case "10000及以上":
            //         this.queryData.miniPrice = 10000;
            //         this.queryData.maxPrice = 0;
            //         // this.queryData.paramName=item.label
            //         break;
            //       default:
            //         let a = item.label.split("-");
            //         this.queryData.miniPrice = parseInt(a[0]);
            //         this.queryData.maxPrice = parseInt(a[1]);
            //         // this.queryData.paramName=item.label
            //         break;
            //     }
            //     if (this.queryData.compareType && this.queryData.compareType === 8) {
            //       this.queryData.paramName = item.label;
            //     }
            //   }
            // });
            this.updateQuery()
        },
        // 改变理疗师
        changePer(val) {
            if (!Object.keys(val).length) {
                // delete this.queryData.empIDs
                this.queryData.empIDs = null
                this.queryData = Object.assign({}, this.queryData)
            } else {
                this.queryData = Object.assign({}, this.queryData, val)
            }
            // 记录被对比的理疗师名字，传给后端
            this.empName = val.paramName
            this.updateQuery()
        },

        // changeStore(data) {
        //   console.log(data.empIDs);
        //    const self = this;
        //   self.query = Object.assign({}, self.query, { storeID: 1,storeIDs:data.empIDs});
        //   self.$store.commit({
        //     type: "setQueryData",
        //     data: self.query
        //   });
        // },

        changeCoupons(val) {
            this.updateQuery()
        },
        // 开启对比 默认对比
        onContrast(val) {
            const self = this
            self.checkId = val ? 1 : 0
            self.showPick = !val
            self.checked = self.checked.map(() => false)
            val
                ? self.checked.splice(0, 1, true)
                : self.checked.splice(0, 1, false)
            // 对比时间默认
            if (val) {
                self.queryData = Object.assign(
                    {},
                    self.queryData,
                    consts.clearCompare
                )
                self.clearQuery(util.report.sameTime(self.query.time))
            } else {
                // 不对比
                if (self.queryData.compareType !== 0) {
                    self.queryData = Object.assign(
                        {},
                        self.queryData,
                        consts.clearCompare,
                        {
                            compareType: 0,
                            comParamName: '',
                            compareParam: '',
                            compareStoreIDs: []
                        }
                    )
                    self.tab_time = self.query.time
                    self.updateQuery()
                    // 反选
                    self.clearQuery([])
                }
                self.$emit('select_header', self.query)
            }
        },
        // 切换对比项目
        updateCheck(index) {
            this.$store.commit({
                type: 'getPieIndex',
                index: ''
            })
            const self = this
            self.checkId = index
            self.checked = self.checked.map(() => false)
            self.checked.splice(index - 1, 1, true)
            self.showPick = false
            self.queryData = Object.assign(
                {},
                self.queryData,
                consts.clearCompare,
                {
                    compareType: 0,
                    comParamName: '',
                    paramName: ''
                }
            )
        },
        // 对比时间
        changeEnd(val) {
            const self = this
            self.showPick = true
            self.query.time_contrast = util.report.sameStart(
                self.query.time,
                val
            )
            self.tab_time = [
                self.query.time.join('~'),
                self.query.time_contrast.join('~')
            ]
            self.$emit('select_header', self.query)
            // 数据
            self.queryData = Object.assign({}, self.queryData, {
                compareType: 1,
                compareParam:
                    self.query.time_contrast[0] +
                    '/' +
                    self.query.time_contrast[1],
                paramName: ''
            })

            self.updateQuery()
        },
        // 对比门店
        changeStore_other(val) {
            this.queryData.comParamName = val.empNames.length > 1 ? '全部' : val.empNames.join(',')
            this.queryData.compareStoreIDs = val.empIDs;
            this.queryData.compareType = 2
            this.updateQuery();
        },
        // 对比会员
        changeMember_other(val) {
            let a = this.queryData.customerType
            this.memberList.forEach(item => {
                if (item.value === val) {
                    this.queryData.comParamName = item.label
                    this.queryData.compareParam = val.toString()
                    this.queryData.compareType = 3
                }
                if (item.value === a) {
                    this.queryData.paramName = item.label
                }
            })
            this.tab_time = this.query.time
            this.updateQuery()
        },
        // 对比顾客
        changeCustomer_other(val) {
            let a = this.queryData.isOld
            this.customerList.forEach(item => {
                if (item.isOld === val) {
                    this.queryData.comParamName = item.label
                    this.queryData.compareParam = val.toString()
                    this.queryData.compareType = 6
                }
                if (item.isOld === a) {
                    this.queryData.paramName = item.label
                }
            })
            this.tab_time = this.query.time
            this.updateQuery()
        },
        // 对比储值卡
        changeCard_other(val) {
            this.cardList.forEach(item => {
                if (item.cardType === val) {
                    switch (item.label) {
                        case '全部':
                            this.queryData.compareParam = '0/0'
                            this.queryData.comParamName = item.label
                            break
                        case '10000及以上':
                            this.queryData.compareParam = '10000/0'
                            this.queryData.comParamName = item.label
                            break
                        default:
                            let a = item.label.split('-')
                            this.queryData.compareParam = a[0] + '/' + a[1]
                            this.queryData.comParamName = item.label
                            break
                    }
                }
                if (item.cardType === this.cardType) {
                    this.queryData.paramName = item.label
                }
            })
            this.queryData.compareType = 8
            this.tab_time = this.query.time
            this.updateQuery()
        },
        // 对比理疗师
        changePerContrant(val) {
            this.queryData.comParamName = val.comParamName
            this.queryData.compareParam = val.empID.toString()
            this.queryData.compareType = 5
            this.queryData.paramName = this.empName
            this.updateQuery()
        },
        // 对比优惠券
        changeCouponsContrant(val) {},
        reinitTime() {
            EventBus.$emit('change-page-number', 1)
            let base =
            {
                // headerType: this.page.headerType,
                // constantKey: this.page.constantKey,
                // parentID: this.page.parentID,
                // type: this.page.type,
                // dateFormat: this.page.dateFormat,
                // sqlType: this.page.sqlType,
                // sortIndex: this.page.sortIndex,
                timelyType: this.page.timelyType,
                // areaType: this.page.areaType
            }
            console.log('reinitTime', this.timeRangeSelected, this.page)
            let index = this.timeRangeSelected
            if (index === 0) { // 月度
                let val = this.moment().format('YYYY-MM')
                this.time_title = '（' + val + '~' + val + '）'
                this.queryData = {
                    ...this.queryData,
                    ...base,
                    pageNum: 1,
                    startTime: val,
                    endTime: val,
                    identifyKey: "operation_monthly_target"
                }
                this.monthValue = [moment().format('YYYY-MM'),moment().format('YYYY-MM')],
                this.monthType = 1
                delete this.queryData.month
                queryUtil.setQuery(this.queryData)
            } else if (index === 1) { // 季度
                const start = moment().startOf('quarter').format('YYYY-MM')
                const end = moment().endOf('quarter').format('YYYY-MM')
                this.time_title = '（' + start + '~' + end + '）'
                this.queryData = {
                    ...this.queryData,
                    ...base,
                    pageNum: 1,
                    startTime: start,
                    endTime: end,
                    identifyKey: "operation_quarterly_target",
                }
                this.quarterValue = [
                    moment().startOf('quarter').format('YYYY-MM'),
                    moment().endOf('quarter').format('YYYY-MM'),
                ]
                this.quarterlyType = 1
                delete this.queryData.month
                queryUtil.setQuery(this.queryData)
            } else if (index === 2) { // 年度
                let val = this.moment().format('YYYY')
                this.time_title = '（' + val + '）'
                this.queryData = {
                    ...this.queryData,
                    ...base,
                    pageNum: 1,
                    month: val,
                    startTime: this.moment().format('YYYY-MM-DD'),
                    endTime: this.moment().format('YYYY-MM-DD'),
                    identifyKey: "operation_yearly_target",
                }
                this.yearType = 1
                this.yearValue = moment().format('YYYY')
                queryUtil.setQuery(this.queryData)
            }
        },
        handleTimeRangeChange(index) {
            this.$emit('time-range-select', index)
            this.monthType = 1
            this.monthValue = [moment().format('YYYY-MM'),moment().format('YYYY-MM')],
            this.yearType = 1
            this.yearValue = moment().format('YYYY')
            this.quarterlyType = 1
            this.quarterValue = [
                moment().startOf('quarter').format('YYYY-MM'),
                moment().endOf('quarter').format('YYYY-MM'),
            ]
        }
    }
}
</script>

<style lang="less" scoped>
.loadingStyle {
    color: #999999;
}
.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-leave-active {
    transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
}
</style>
